import { Users, Briefcase, Wrench, Shield } from 'lucide-react';
import { KPICard } from '../shared/KPICard';
import { USER_ROLE_LABELS } from '../shared/analytics-constants';
import type { LucideIcon } from 'lucide-react';
import type { ActivityData, AnalyticsUserRole } from '../../../types/analytics.types';

type LoginKPICardsProps = {
  kpiCards: ActivityData['kpiCards'];
};

const ROLE_ICONS: Record<AnalyticsUserRole, LucideIcon> = {
  CARE_SEEKER: Users,
  FINANCIAL_ADVISOR: Briefcase,
  SERVICE_PROVIDER: Wrench,
  ADMIN: Shield,
};

const ROLE_ORDER: AnalyticsUserRole[] = [
  'CARE_SEEKER',
  'FINANCIAL_ADVISOR',
  'SERVICE_PROVIDER',
  'ADMIN',
];

export const LoginKPICards = ({ kpiCards }: LoginKPICardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {ROLE_ORDER.map((role) => {
        const card = kpiCards[role];
        return (
          <KPICard
            key={role}
            title={USER_ROLE_LABELS[role]}
            value={card.totalLogins.toLocaleString('en-US')}
            subtitle={`${card.uniqueUsers.toLocaleString('en-US')} unique users`}
            icon={ROLE_ICONS[role]}
          />
        );
      })}
    </div>
  );
};
